import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import './LoginScreen.css';
import TwoFactorCodeInput from './TwoFactorCodeInput';

export default function LoginScreen({ logo, institutionName = 'OnTest', kicker, background, heroTitle, heroDescription, credential, password, onCredentialChange, onPasswordChange, onSubmit, error, submitting, credentialType = 'email', verification = null, notice = '' }) {
    const [showPassword, setShowPassword] = useState(false);
    return <div className="ontest-access">
        <section className="access-panel" aria-label={kicker}>
            <div className="access-body">
                <div className="access-logo"><img src={logo} alt={institutionName} /></div>
                <div className="access-intro">
                    <span className="access-kicker">{kicker}</span>
                    <h1 className="access-title">{verification ? 'Confirme seu acesso' : 'Bem-vindo'}</h1>
                    <p className="access-subtitle">{verification ? <>Enviamos um código de seis caracteres para <strong>{verification.email}</strong>. Digite abaixo para continuar.</> : 'Acesse sua conta para continuar.'}</p>
                </div>
                <form className="access-form" onSubmit={onSubmit}>
                    {verification ? <div className="access-field">
                        <span className="access-code-label">Código de verificação</span>
                        <TwoFactorCodeInput value={verification.code} onChange={verification.onChange} disabled={submitting || verification.resending} />
                        <span className="access-code-help">Use letras e números. O código expira em 10 minutos.</span>
                    </div> : <>
                    <div className="access-field">
                        <label htmlFor="access-credential">E-mail <span aria-hidden="true">*</span></label>
                        <input id="access-credential" name="credencial" type={credentialType} value={credential} onChange={onCredentialChange} placeholder="E-mail" autoComplete="username" required />
                    </div>
                    <div className="access-field">
                        <label htmlFor="access-password">Senha <span aria-hidden="true">*</span></label>
                        <div className="access-password">
                            <input id="access-password" name="password" type={showPassword ? 'text' : 'password'} value={password} onChange={onPasswordChange} placeholder="Digite sua senha" autoComplete="current-password" required />
                            <button className="access-password-toggle" type="button" aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'} aria-pressed={showPassword} onClick={() => setShowPassword(value => !value)}>
                                {showPassword ? <AiFillEyeInvisible aria-hidden="true" /> : <AiFillEye aria-hidden="true" />}
                            </button>
                        </div>
                    </div>
                    </>}
                    {notice && <div className="access-notice" role="status">{notice}</div>}
                    {error && <div className="access-error" role="alert">{error}</div>}
                    <button className="access-submit" type="submit" disabled={submitting || (verification && (verification.resending || verification.code.some(character => !character)))}>
                        {submitting && <span className="access-spinner" aria-hidden="true" />}
                        {submitting ? (verification ? 'Validando...' : 'Entrando...') : (verification ? 'Confirmar e entrar' : 'Entrar')}
                    </button>
                    {verification && <div className="access-code-actions">
                        <button type="button" className="access-code-resend" disabled={submitting || verification.resending || verification.seconds > 0} onClick={verification.onResend}>
                            {verification.resending ? 'Enviando...' : verification.seconds > 0 ? `Reenviar em ${verification.seconds}s` : 'Reenviar código'}
                        </button>
                        <button type="button" className="access-code-back" disabled={submitting || verification.resending} onClick={verification.onBack}>Voltar ao login</button>
                    </div>}
                </form>
                <footer className="access-footer">© {new Date().getFullYear()} OnTest</footer>
            </div>
        </section>
        <aside className="access-hero" style={{ backgroundImage: `url(${background})` }}>
            <div className="access-hero-copy"><span>OnTest</span><h2>{heroTitle}</h2><p>{heroDescription}</p></div>
        </aside>
    </div>;
}

export function LoginScreenLoading() {
    return <div className="ontest-access-loading" role="status"><span className="access-spinner" aria-hidden="true" /><span>Carregando...</span></div>;
}
